import { combineReducers } from 'redux';

import gameReducer from './gameReducer';

const rootReducers = combineReducers({
    game: gameReducer
})

export default rootReducers;